<template>
  <div class="card mt-4">
    <div class="card-header pb-0">
      <div class="d-flex justify-content-between align-items-center">
        <div>
          <h6 class="mb-0">Lead Generation & Outreach</h6>
          <p class="text-sm text-secondary mb-0">Automated church lead discovery, AI categorization, and cold email outreach</p>
        </div>
      </div>
    </div>

    <div class="card-body">
      <div class="row text-center">
        <div class="col-4">
          <h4 class="mb-0">{{ loading ? '—' : totalLeads }}</h4>
          <p class="text-sm text-secondary mb-0">Total Leads</p>
        </div>
        <div class="col-4">
          <h4 class="mb-0">{{ loading ? '—' : pendingContacts }}</h4>
          <p class="text-sm text-secondary mb-0">Pending Contacts</p>
        </div>
        <div class="col-4">
          <h4 class="mb-0">{{ loading ? '—' : deliveryRate + '%' }}</h4>
          <p class="text-sm text-secondary mb-0">Delivery Rate</p>
        </div>
      </div>

      <div class="d-flex justify-content-end mt-3">
        <MaterialButton type="button" color="info" size="sm" @click="modalOpen = true">
          Manage Leads
        </MaterialButton>
      </div>
    </div>

    <LeadsManagementModal v-model="modalOpen" @closed="fetchStats" />
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import MaterialButton from '@/components/common/MaterialButton.vue'
import LeadsManagementModal from './LeadsManagementModal.vue'
import api from '@/config/api'

const loading = ref(true)
const stats = ref(null)
const modalOpen = ref(false)

const totalLeads = computed(() => {
  const byStatus = stats.value?.organizations_by_status || {}
  return Object.values(byStatus).reduce((sum, count) => sum + count, 0)
})

const pendingContacts = computed(() => stats.value?.contacts_by_status?.pending || 0)

const deliveryRate = computed(() => stats.value?.emails?.delivery_rate ?? 0)

async function fetchStats() {
  loading.value = true
  try {
    const response = await api.get('/admin/leads/stats')
    stats.value = response.data?.output || null
  } catch (e) {
    console.error('Error fetching lead stats:', e)
  } finally {
    loading.value = false
  }
}

onMounted(fetchStats)
</script>
